import {MODULE_DISTRIBUTION_APP} from '../../../../constants/main.module.constants';
import AqlQueryCreateEditComponent from './components/bundle/create/aql.query.create.edit.component';
import AqlQueryCreateEditService
    from './components/bundle/create/aqlQueryCreateEditService/aql.query.create.edit.service';
import CreateBundleComponent from './components/bundle/create/bundle.create.component';
import EditBundleComponent from './components/bundle/create/bundle.edit.component';
import BundleCreationDryRunService
    from './components/bundle/create/bundleCreationDryDunService/bundle.creation.dry.run.service';
import CreateBundleDAO from './components/bundle/create/DAO/CreateBundleDAO';
import CreateBundleDAOProperties from './components/bundle/create/DAO/CreateBundleDAOProperties';
import BundleSpecComponent from './components/bundle/version/components/bundleSpec/bundle.spec.component';
import BundleVersionDAO from './components/bundle/version/DAO/BundleVersionDAO';
import BundleVersionDAOProperties from './components/bundle/version/DAO/BundleVersionDAOProperties';
import DistributionStatusComponent from './components/distributionStatus/distribution.status.component';
import XraySeverityStatusComponent from './components/xrayServerityStatus/xray.severity.status.component';
import DistributionBundlesDAO from './DAO/bundles/DistributionBundlesDAO';
import DistributionBundlesDAOProperties from './DAO/bundles/DistributionBundlesDAOProperties';
import DistributionPermissionsDAO from './DAO/permissions/DistributionPermissionsDAO';
import DistributionPermissionsDAOProperties from './DAO/permissions/DistributionPermissionsDAOProperties';

export const MODULE_DISTRIBUTION_COMPONENTS = MODULE_DISTRIBUTION_APP + '.distribution';

angular.module(MODULE_DISTRIBUTION_COMPONENTS, []);

class DistributionConfig {
	constructor($stateProvider) {
		$stateProvider
			.state(CreateBundleComponent.META.state)
			.state(EditBundleComponent.META.state)
	}
}

DistributionConfig.$inject = ['$stateProvider'];

angular.register(MODULE_DISTRIBUTION_COMPONENTS)
       .services([
	       DistributionBundlesDAOProperties,
	       DistributionBundlesDAO,
	       BundleVersionDAO,
	       BundleVersionDAOProperties,
	       DistributionPermissionsDAO,
	       DistributionPermissionsDAOProperties,
	       AqlQueryCreateEditService,
	       CreateBundleDAO,
	       CreateBundleDAOProperties,
	       BundleCreationDryRunService
       ])
       .components([
	       DistributionStatusComponent,
	       CreateBundleComponent,
	       EditBundleComponent,
	       BundleSpecComponent,
	       AqlQueryCreateEditComponent,
           XraySeverityStatusComponent
       ])
       .config(DistributionConfig);



// WEBPACK FOOTER //
// ./modules/distribution/modules/distribution/index.js